import React from 'react';
import { TafValidationResult } from '@taf-ui/react';

import './TafValidationError.css';

type TafValidationErrorProps = {
  message: string;
  isShown: boolean;
};

const TafValidationError: React.FC<TafValidationErrorProps> = ({ message, isShown }) => {
  return isShown ? (
      <div className="error-container">
        <TafValidationResult messages={message} />
      </div>
  ) : null;
};

export default TafValidationError;
